import { AuthForgotPasswordRequest } from "../interfaces/AuthForgotPasswordRequest";
import { AuthLoginRequest } from "../interfaces/AuthLoginRequest";
import { AuthMessageResponse } from "../interfaces/AuthMessageResponse";
import { AuthRegisterRequest } from "../interfaces/AuthRegisterRequest";
import { AuthResetPasswordRequest } from "../interfaces/AuthResetPasswordRequest";
import { AuthResponse } from "../interfaces/AuthResponse";
import { AuthVerifyRequest } from "../interfaces/AuthVerifyRequest";
import { cloudApi } from "./cloudApi";

export const authApi = cloudApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<AuthResponse, AuthLoginRequest>({
      query: (payload) => ({
        url: `/auth/login`,
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
    }),
    register: builder.mutation<AuthResponse, AuthRegisterRequest>({
      query: (payload) => ({
        url: `/auth/register`,
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
    }),
    verify: builder.mutation<AuthResponse, AuthVerifyRequest>({
      query: (payload) => ({
        url: `/auth/verify`,
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
    }),
    forgotPassword: builder.mutation<AuthMessageResponse, AuthForgotPasswordRequest>({
      query: (payload) => ({
        url: `/auth/forgot-password`,
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
    }),
    resetPassword: builder.mutation<AuthMessageResponse, AuthResetPasswordRequest>({
      query: (payload) => ({
        url: `/auth/reset-password`,
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useLoginMutation, //
  useRegisterMutation,
  useVerifyMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
} = authApi;
